import React from "react";
import _ from "underscore";
import { isNotEmpty } from "../../../framework/utils";
import { SURVEY_STATUS } from "../../../model/vars";
import M from "../../../strings";
import { format, optional, parseBoolean } from "../../../utils/lang";
import * as SurveyUtils from "../../utils/surveys";
import * as RetailersUtils from "../../utils/retailers";
import ProgressBar from "./progressBar";
import GradedValue, { gradedComponent, GRADE_TYPES } from "./gradedValue";

export class SurveyCard extends React.Component {
    
    render() {
        return(
            <SurveySummary
                {...this.props}
                isCard={true}
                useProgressBar={true}
            />
        )
    }
}

export class SurveySummary extends React.Component {

    onClick() {
        const surveySummary = optional(this.props.surveySummary, {});

        if (this.props.onClick && _.isFunction(this.props.onClick)) {
            this.props.onClick(surveySummary);
        }
    }

    render() {
        const isCard = parseBoolean(optional(this.props.isCard), false),
            useProgressBar = parseBoolean(optional(this.props.useProgressBar, false)),
            surveySummary = optional(this.props.surveySummary, {}),
            store = optional(surveySummary.store, {}),
            survey = optional(surveySummary.survey, {}),
            surveyTemplate = optional(survey.surveyTemplate, {}),
            lastEditingUser = optional(surveySummary.lastEditingUser, {}),
            {status, lastEditTime} = survey,
            lastScore = optional(survey.lastScore, {}),
            score = SurveyUtils.getScoreValue(lastScore),//_.isFinite(lastScore.value) ? lastScore.value : 0,
            progress = _.isFinite(lastScore.progress) ? lastScore.progress : 0,
            totalQuestions = _.isFinite(lastScore.totalQuestions) ? lastScore.totalQuestions : 0,
            answeredQuestions = _.isFinite(lastScore.answeredQuestions) ? lastScore.answeredQuestions : 0,
            storeDescription = RetailersUtils.getStoreDescription(store, true),
            storeAddress = RetailersUtils.formatStoreAddress(store),
            template = surveyTemplate.description,
            Wrapper = gradedComponent("div");

        let className = "survey-summary";

        if (isCard) {
            className += " survey-summary--card";
        }
        
        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }
        
        return (
            <Wrapper
                className={className}
                value={score}
                gradeType={GRADE_TYPES.SCORE}
                onClick={this.onClick.bind(this)}
                invert={!isCard}
            >
                <div
                    className="survey-summary__status"
                >
                    <GradedValue
                        className="survey-summary__score"
                        gradeType={GRADE_TYPES.SCORE}
                        value={score}
                        invert={isCard}
                    />
                </div>
                <div
                    className="survey-summary__info"
                >
                    <div
                        className="survey-summary__header"
                    >
                        {storeDescription}
                    </div>
                    {!useProgressBar && <div
                        className="survey-summary__text"
                    >
                        {storeAddress}
                    </div>}
                    <div
                        className="survey-summary__text"
                    >
                        {template}
                    </div>
                    {!useProgressBar && (status === SURVEY_STATUS.OPEN ? (<div
                        className="survey-summary__text"
                    >
                        {M("ongoingSurvey")}
                    </div>) : (
                        <div
                            className="survey-summary__text"
                        >
                            {new Date(lastEditTime).toDateString()}, {lastEditingUser.name} {lastEditingUser.lastname}
                        </div>
                    ))}
                    {useProgressBar && (
                        answeredQuestions != 0 ? (<div
                            className="survey-summary__progress"
                        >
                            <ProgressBar
                                value={progress}
                            />
                            <div
                                className="survey-summary__text"
                            >
                                {format(M("surveyProgressStatus"), answeredQuestions, totalQuestions)}
                            </div>
                        </div>) : (<div
                            className="survey-summary__text"
                        >
                            {M("surveyNotStarted")}
                        </div>)
                    )}
                </div>
            </Wrapper>
        )
    }
}